import { CheckCircle } from "lucide-react";

const ABOUT_IMAGE = "/images/about-team.jpg";

const values = [
  "Deep ServiceNow platform expertise",
  "Practical, collaborative approach",
  "Trust and long-term relationships",
  "Scalable, reliable solutions",
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0047AB] mb-3">
            About Us
          </p>
          <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-slate-900">
            Who We Are
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-start">
          {/* Left: Image */}
          <div className="relative">
            <div className="border border-slate-200 rounded-xl overflow-hidden">
              <img
                src={ABOUT_IMAGE}
                alt="DigitalBlue team in modern office"
                data-testid="about-image"
                className="w-full h-[400px] lg:h-[480px] object-cover"
              />
            </div>
            {/* Floating stat card */}
            <div
              data-testid="about-stat-card"
              className="absolute -bottom-6 -right-4 lg:-right-6 bg-white border border-slate-200 rounded-lg p-6 shadow-sm"
            >
              <p className="text-xs font-bold uppercase tracking-[0.15em] text-slate-500 mb-1">Based in</p>
              <p className="text-2xl font-bold text-[#0047AB] tracking-tight">South Australia</p>
            </div>
          </div>

          {/* Right: Content */}
          <div className="space-y-6 lg:pt-4">
            <p className="text-base text-slate-600 leading-relaxed">
              Based in South Australia, we are a specialist consulting firm with deep expertise
              in the ServiceNow platform. We bring extensive experience delivering practical,
              high-quality solutions that drive real outcomes for our clients.
            </p>
            <p className="text-base text-slate-600 leading-relaxed">
              Our approach is practical and collaborative. We take the time to understand your
              business, your challenges, and your goals, then design and deliver ServiceNow
              solutions that are scalable and reliable.
            </p>
            <p className="text-base text-slate-600 leading-relaxed">
              We are proud to be different than many firms you may have engaged, and place a
              strong emphasis on trust and long term relationships and doing what is right for
              your organisation.
            </p>

            {/* Values grid */}
            <div className="pt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {values.map((v) => (
                <div
                  key={v}
                  data-testid="about-value-item"
                  className="flex items-start gap-3 p-3 border border-slate-200 rounded-md bg-white"
                >
                  <CheckCircle size={18} className="text-[#0047AB] mt-0.5 flex-shrink-0" />
                  <span className="text-sm font-medium text-slate-700">{v}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
